export const SentryUnmask: React.FC<React.PropsWithChildren> = ({ children }) => <div data-sentry-unmask>{children}</div>;
